/* src/app/components/clinical-investigation/clinical-investigation.component.scss */
/*# sourceMappingURL=clinical-investigation.component.css.map */
